module.exports = __webpack_public_path__ + "static/img/internships-24.5c4f852.png";


//////////////////
// WEBPACK FOOTER
// ./static/internships-24.png
// module id = beic
// module chunks = 1